// tslint:disable
export var TCSInsuranceType;
(function (TCSInsuranceType) {
    // Pharmacy
    TCSInsuranceType[TCSInsuranceType["Pharmacy"] = 1] = "Pharmacy";
    // Medical
    TCSInsuranceType[TCSInsuranceType["Medical"] = 2] = "Medical";
    // Medical / Pharmacy
    TCSInsuranceType[TCSInsuranceType["Both"] = 3] = "Both";
})(TCSInsuranceType || (TCSInsuranceType = {}));
TCSInsuranceType['PHARMACY'] = 1;
TCSInsuranceType['MEDICAL'] = 2;
TCSInsuranceType['BOTH'] = 3;
//# sourceMappingURL=TCSInsuranceType.js.map